import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';

const DeepgramDebugContext = createContext();

const initialState = {
  status: 'idle',
  framesSent: 0,
  bytesSent: 0,
  transcripts: 0,
  lastEvent: null,
  lastTranscriptAt: null,
  lastAudioChunkAt: null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'STATUS':
      return {
        ...state,
        status: action.status || state.status,
        lastEvent: action.message || null,
      };
    case 'ERROR':
      return {
        ...state,
        status: 'error',
        lastEvent: action.error || action.message || 'Unknown error',
      };
    case 'FRAME':
      return {
        ...state,
        framesSent: state.framesSent + 1,
        bytesSent: state.bytesSent + (action.bytes || 0),
        lastAudioChunkAt: action.timestamp || Date.now(),
      };
    case 'TRANSCRIPT':
      return {
        ...state,
        transcripts: state.transcripts + 1,
        lastTranscriptAt: action.timestamp || Date.now(),
        lastEvent: action.message || state.lastEvent,
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

export function DeepgramDebugProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const safeDispatch = useCallback((action) => {
    if (!action) return;
    dispatch(action);
  }, []);

  const value = useMemo(() => ({
    state,
    dispatch: safeDispatch,
  }), [state, safeDispatch]);

  return (
    <DeepgramDebugContext.Provider value={value}>
      {children}
    </DeepgramDebugContext.Provider>
  );
}

export function useDeepgramDebug() {
  const context = useContext(DeepgramDebugContext);
  if (!context) {
    throw new Error('useDeepgramDebug deve ser usado dentro de DeepgramDebugProvider');
  }
  return context;
}

